import React, {Component } from "react"
import MetaTags from 'react-meta-tags';

class Contactus extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            customer: {
                fullName: props.fullName,
                email: props.email,
                subject: props.subject,
                message: props.message
            }
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const data = new FormData(event.target);

        fetch('https://sellercentral-staging.shopperr.in/sscapi/mobile/lead', {
            method: 'POST',
            body: data,
        });
    }

    handleFullNameChanged(event) {
        var customer = this.state.customer;
        customer.fullName = event.target.value;

        this.setState({ customer: customer });
    }

    handleemailChanged(event) {
        var customer = this.state.customer;
        customer.email = event.target.value;

        this.setState({ customer: customer });
    }

    handlesubjectChanged(event) {
        var customer = this.state.customer;
        customer.subject = event.target.value;

        this.setState({ customer: customer });
    }

    handlemessageChanged(event) {
        var customer = this.state.customer;
        customer.message = event.target.value;

        this.setState({ customer: customer });
    }

    handleButtonClicked() {
        console.log(this.state.customer);
    }


    componentDidMount() {
        window.scrollTo(0, 0)

    }

    render() {
        return (

            <div class="wrapper">
                <MetaTags>
                    <title>Contact Us</title>
                    <description>Shopperr is one of the most evolved B2B platform that enables members to source products of international brands directly from manufacturers and suppliers.</description>
                    {/* <meta id="description" name="mg-description" content="About Us In Shopperr." />
                    <meta id="keywords" property="mg-keyword" content="head,body,html,tags" /> */}

                </MetaTags>
                <div role="main" className="main">
                    {/* Google Maps - Go to the bottom of the page to change settings and map location. */}
                    <div
                        id="googlemaps"
                        className="google-map mt-0"
                        style={{ height: 500, position: "relative", overflow: "hidden" }}
                    >
                        <div
                            style={{
                                height: "100%",
                                width: "100%",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                backgroundColor: "rgb(229, 227, 223)"
                            }}
                        >
                            <div
                                className="gm-style"
                                style={{
                                    position: "absolute",
                                    zIndex: 0,
                                    left: 0,
                                    top: 0,
                                    height: "100%",
                                    width: "100%",
                                    padding: 0,
                                    borderWidth: 0,
                                    margin: 0
                                }}
                            >
                                <div>
                                    <button
                                        draggable="false"
                                        aria-label="Keyboard shortcuts"
                                        title="Keyboard shortcuts"
                                        type="button"
                                        style={{
                                            background: "none transparent",
                                            display: "block",
                                            border: "none",
                                            margin: 0,
                                            padding: 0,
                                            textTransform: "none",
                                            appearance: "none",
                                            position: "absolute",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            zIndex: 1000002,
                                            left: "-100000px",
                                            top: "-100000px"
                                        }}
                                    />
                                </div>
                                <div
                                    tabIndex={0}
                                    aria-label="Map"
                                    aria-roledescription="map"
                                    role="group"
                                    style={{
                                        position: "absolute",
                                        zIndex: 0,
                                        left: 0,
                                        top: 0,
                                        height: "100%",
                                        width: "100%",
                                        padding: 0,
                                        borderWidth: 0,
                                        margin: 0,
                                        cursor:
                                            'url("https://maps.gstatic.com/mapfiles/openhand_8_8.cur"), default',
                                        touchAction: "pan-x pan-y"
                                    }}
                                >
                                    <div
                                        style={{
                                            zIndex: 1,
                                            position: "absolute",
                                            left: "50%",
                                            top: "50%",
                                            width: "100%",
                                            transform: "translate(0px, 0px)"
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                zIndex: 100,
                                                width: "100%"
                                            }}
                                        >
                                            <div style={{ position: "absolute", left: 0, top: 0, zIndex: 0 }}>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        zIndex: 989,
                                                        transform: "matrix(1, 0, 0, 1, -50, -183)"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-256px",
                                                            top: 0,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-256px",
                                                            top: "-256px",
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: "-256px",
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 256,
                                                            top: "-256px",
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 256,
                                                            top: 0,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 256,
                                                            top: 256,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 256,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-256px",
                                                            top: 256,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-512px",
                                                            top: 256,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-512px",
                                                            top: 0,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-512px",
                                                            top: "-256px",
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 512,
                                                            top: "-256px",
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 512,
                                                            top: 0,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 512,
                                                            top: 256,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-768px",
                                                            top: 256,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-768px",
                                                            top: 0,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-768px",
                                                            top: "-256px",
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 768,
                                                            top: "-256px",
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 768,
                                                            top: 0,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: 768,
                                                            top: 256,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-1024px",
                                                            top: 256,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-1024px",
                                                            top: 0,
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            left: "-1024px",
                                                            top: "-256px",
                                                            width: 256,
                                                            height: 256
                                                        }}
                                                    >
                                                        <div style={{ width: 256, height: 256 }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                zIndex: 101,
                                                width: "100%"
                                            }}
                                        />
                                        <div
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                zIndex: 102,
                                                width: "100%"
                                            }}
                                        />
                                        <div
                                            style={{
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                zIndex: 103,
                                                width: "100%"
                                            }}
                                        >
                                            <div
                                                style={{ position: "absolute", left: 0, top: 0, zIndex: -1 }}
                                            >
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        zIndex: 989,
                                                        transform: "matrix(1, 0, 0, 1, -50, -183)"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 0
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-256px",
                                                            top: 0
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-256px",
                                                            top: "-256px"
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 0,
                                                            top: "-256px"
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 256,
                                                            top: "-256px"
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 256,
                                                            top: 0
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 256,
                                                            top: 256
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 0,
                                                            top: 256
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-256px",
                                                            top: 256
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-512px",
                                                            top: 256
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-512px",
                                                            top: 0
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-512px",
                                                            top: "-256px"
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 512,
                                                            top: "-256px"
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 512,
                                                            top: 0
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 512,
                                                            top: 256
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-768px",
                                                            top: 256
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-768px",
                                                            top: 0
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-768px",
                                                            top: "-256px"
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 768,
                                                            top: "-256px"
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 768,
                                                            top: 0
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: 768,
                                                            top: 256
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-1024px",
                                                            top: 256
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-1024px",
                                                            top: 0
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            overflow: "hidden",
                                                            position: "absolute",
                                                            left: "-1024px",
                                                            top: "-256px"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    width: 26,
                                                    height: 46,
                                                    overflow: "hidden",
                                                    position: "absolute",
                                                    left: "-12px",
                                                    top: "-46px",
                                                    zIndex: 0
                                                }}
                                            >
                                                <img
                                                    alt
                                                    src="img/pin.png"
                                                    draggable="false"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        userSelect: "none",
                                                        border: 0,
                                                        padding: 0,
                                                        margin: 0,
                                                        maxWidth: "none",
                                                        width: 26,
                                                        height: 46
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div style={{ position: "absolute", left: 0, top: 0, zIndex: 0 }}>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    zIndex: 989,
                                                    transform: "matrix(1, 0, 0, 1, -50, -183)"
                                                }}
                                            >
                                                <div style={{
                                                        position: "absolute",
                                                        left: 256,
                                                        top: 256,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i604!3i770!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=110815"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 512,
                                                        top: "-256px",
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i605!3i768!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=19085"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i603!3i769!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=50252"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 768,
                                                        top: 256,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i606!3i770!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=90053"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 768,
                                                        top: "-256px",
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i606!3i768!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=8704"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-512px",
                                                        top: "-256px",
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i601!3i768!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=60609"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 256,
                                                        top: 0,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i604!3i769!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=39871"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 256,
                                                        top: "-256px",
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i604!3i768!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=29466"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-256px",
                                                        top: "-256px",
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i602!3i768!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=50228"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-512px",
                                                        top: 256,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i601!3i770!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=10887"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-256px",
                                                        top: 256,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i602!3i770!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=506"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 512,
                                                        top: 256,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i605!3i770!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=100434"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-1024px",
                                                        top: "-256px",
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i599!3i768!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=17856"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-768px",
                                                        top: "-256px",
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i600!3i768!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=70990"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 512,
                                                        top: 0,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i605!3i769!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=29490"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 256,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i603!3i770!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=121196"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-512px",
                                                        top: 0,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i601!3i769!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=71014"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-768px",
                                                        top: 0,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i600!3i769!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=81395"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-1024px",
                                                        top: 256,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i599!3i770!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=99205"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-768px",
                                                        top: 256,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i600!3i770!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=21268"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-256px",
                                                        top: 0,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i602!3i769!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=60633"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: "-1024px",
                                                        top: 0,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i599!3i769!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=28261"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 768,
                                                        top: 0,
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i606!3i769!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=19109"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: "-256px",
                                                        width: 256,
                                                        height: 256,
                                                        transition: "opacity 200ms linear 0s"
                                                    }}
                                                >
                                                    <img
                                                        draggable="false"
                                                        alt
                                                        role="presentation"
                                                        src="https://maps.googleapis.com/maps/vt?pb=!1m5!1m4!1i11!2i603!3i768!4i256!2m3!1e0!2sm!3i566292376!3m12!2sen-US!3sUS!5e18!12m4!1e68!2m2!1sset!2sRoadmap!12m3!1e37!2m1!1ssmartmaps!4e0&key=AIzaSyAhpYHdYRY2U6V_VfyyNtkPHhywLjDkhfg&token=39847"
                                                        style={{
                                                            width: 256,
                                                            height: 256,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="gm-style-pbc"
                                        style={{
                                            zIndex: 2,
                                            position: "absolute",
                                            height: "100%",
                                            width: "100%",
                                            padding: 0,
                                            borderWidth: 0,
                                            margin: 0,
                                            left: 0,
                                            top: 0,
                                            opacity: 0
                                        }}
                                    >
                                        <p className="gm-style-pbt" />
                                    </div>
                                    <div
                                        style={{
                                            zIndex: 3,
                                            position: "absolute",
                                            height: "100%",
                                            width: "100%",
                                            padding: 0,
                                            borderWidth: 0,
                                            margin: 0,
                                            left: 0,
                                            top: 0,
                                            touchAction: "pan-x pan-y"
                                        }}
                                    >
                                        <div
                                            style={{
                                                zIndex: 4,
                                                position: "absolute",
                                                left: "50%",
                                                top: "50%",
                                                width: "100%",
                                                transform: "translate(0px, 0px)"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 0,
                                                    zIndex: 104,
                                                    width: "100%"
                                                }}
                                            />
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 0,
                                                    zIndex: 105,
                                                    width: "100%"
                                                }}
                                            />
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 0,
                                                    zIndex: 106,
                                                    width: "100%"
                                                }}
                                            >
                                                <div
                                                    title
                                                    role="button"
                                                    tabIndex={0}
                                                    style={{
                                                        width: 26,
                                                        height: 46,
                                                        overflow: "hidden",
                                                        position: "absolute",
                                                        cursor: "pointer",
                                                        touchAction: "none",
                                                        left: "-12px",
                                                        top: "-46px",
                                                        zIndex: 0
                                                    }}
                                                >
                                                    <img
                                                        alt
                                                        src="https://maps.gstatic.com/mapfiles/transparent.png"
                                                        draggable="false"
                                                        style={{
                                                            width: 26,
                                                            height: 46,
                                                            userSelect: "none",
                                                            border: 0,
                                                            padding: 0,
                                                            margin: 0,
                                                            maxWidth: "none"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 0,
                                                    zIndex: 107,
                                                    width: "100%"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        cursor: "default",
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        zIndex: -111
                                                    }}
                                                >
                                                    <div
                                                        className="gm-style-iw-a"
                                                        style={{ position: "absolute", left: 0, top: 0 }}
                                                    >
                                                        <div
                                                            className="gm-style-iw-t"
                                                            style={{ right: "-1px", bottom: 57 }}
                                                        >
                                                            <div
                                                                role="dialog"
                                                                tabIndex={-1}
                                                                className="gm-style-iw gm-style-iw-c"
                                                                style={{
                                                                    paddingRight: 0,
                                                                    paddingBottom: 0,
                                                                    maxWidth: 648,
                                                                    maxHeight: 323,
                                                                    minWidth: 0
                                                                }}
                                                            >
                                                                <div
                                                                    className="gm-style-iw-d"
                                                                    style={{ overflow: "scroll", maxHeight: 305 }}
                                                                >
                                                                    <div>
                                                                        <div className="gmap_marker">
                                                                            <strong>New York Office</strong>
                                                                            <br />
                                                                            New York, NY 10017
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <button
                                                                    draggable="false"
                                                                    aria-label="Close"
                                                                    title="Close"
                                                                    type="button"
                                                                    className="gm-ui-hover-effect"
                                                                    style={{
                                                                        background: "none",
                                                                        display: "block",
                                                                        border: 0,
                                                                        margin: 0,
                                                                        padding: 0,
                                                                        textTransform: "none",
                                                                        appearance: "none",
                                                                        position: "absolute",
                                                                        cursor: "pointer",
                                                                        userSelect: "none",
                                                                        top: "-6px",
                                                                        right: "-6px",
                                                                        width: 30,
                                                                        height: 30
                                                                    }}
                                                                    tabIndex={0}
                                                                >
                                                                    <img
                                                                        src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E"
                                                                        alt
                                                                        style={{
                                                                            pointerEvents: "none",
                                                                            display: "block",
                                                                            width: 14,
                                                                            height: 14,
                                                                            margin: 8
                                                                        }}
                                                                    />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <iframe
                                    aria-hidden="true"
                                    frameBorder={0}
                                    tabIndex={-1}
                                    style={{
                                        zIndex: -1,
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        top: 0,
                                        left: 0,
                                        border: "none"
                                    }}
                                />
                                <div
                                    style={{
                                        pointerEvents: "none",
                                        width: "100%",
                                        height: "100%",
                                        boxSizing: "border-box",
                                        position: "absolute",
                                        zIndex: 1000002,
                                        opacity: 0,
                                        border: "2px solid rgb(26, 115, 232)"
                                    }}
                                />
                                <div>
                                    <div
                                        className="gmnoprint"
                                        style={{
                                            margin: 10,
                                            zIndex: 0,
                                            position: "absolute",
                                            cursor: "pointer",
                                            left: 0,
                                            top: 0
                                        }}
                                    >
                                        <div
                                            className="gm-style-mtc"
                                            style={{ float: "left", position: "relative" }}
                                        >
                                            <button
                                                draggable="false"
                                                aria-label="Show street map"
                                                title="Show street map"
                                                type="button"
                                                aria-pressed="true"
                                                style={{
                                                    background: "none padding-box rgb(255, 255, 255)",
                                                    display: "table-cell",
                                                    border: 0,
                                                    margin: 0,
                                                    padding: "0px 17px",
                                                    textTransform: "none",
                                                    appearance: "none",
                                                    position: "relative",
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                    direction: "ltr",
                                                    overflow: "hidden",
                                                    textAlign: "center",
                                                    height: 40,
                                                    verticalAlign: "middle",
                                                    color: "rgb(0, 0, 0)",
                                                    fontFamily: "Roboto, Arial, sans-serif",
                                                    fontSize: 18,
                                                    borderBottomLeftRadius: 2,
                                                    borderTopLeftRadius: 2,
                                                    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
                                                    minWidth: 35,
                                                    fontWeight: 500
                                                }}
                                                id="0DEBA4DD-2306-403C-945F-A426B9ABFD59"
                                                aria-expanded="false"
                                            >
                                                Map
                                            </button>
                                            <ul
                                                role="menu"
                                                aria-labelledby="0DEBA4DD-2306-403C-945F-A426B9ABFD59"
                                                style={{
                                                    backgroundColor: "white",
                                                    listStyle: "none",
                                                    padding: 2,
                                                    margin: 0,
                                                    zIndex: -1,
                                                    borderBottomLeftRadius: 2,
                                                    borderBottomRightRadius: 2,
                                                    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
                                                    position: "absolute",
                                                    left: 0,
                                                    top: 40,
                                                    textAlign: "left",
                                                    display: "none"
                                                }}
                                            >
                                                <li
                                                    tabIndex={-1}
                                                    role="menuitemcheckbox"
                                                    aria-label="Show street map with terrain"
                                                    draggable="false"
                                                    title="Show street map with terrain"
                                                    aria-checked="false"
                                                    style={{
                                                        color: "black",
                                                        fontFamily: "Roboto, Arial, sans-serif",
                                                        userSelect: "none",
                                                        fontSize: 18,
                                                        backgroundColor: "rgb(255, 255, 255)",
                                                        padding: "5px 8px 5px 5px",
                                                        direction: "ltr",
                                                        textAlign: "left",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                >
                                                    <span>
                                                        <img
                                                            src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3Cpath%20d%3D%22M19%203H5c-1.11%200-2%20.9-2%202v14c0%201.1.89%202%202%202h14c1.11%200%202-.9%202-2V5c0-1.1-.89-2-2-2zm-9%2014l-5-5%201.41-1.41L10%2014.17l7.59-7.59L19%208l-9%209z%22/%3E%3C/svg%3E"
                                                            alt
                                                            style={{
                                                                height: "1em",
                                                                width: "1em",
                                                                transform: "translateY(0.15em)",
                                                                display: "none"
                                                            }}
                                                        />
                                                        <img
                                                            src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M19%205v14H5V5h14m0-2H5c-1.1%200-2%20.9-2%202v14c0%201.1.9%202%202%202h14c1.1%200%202-.9%202-2V5c0-1.1-.9-2-2-2z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E"
                                                            alt
                                                            style={{
                                                                height: "1em",
                                                                width: "1em",
                                                                transform: "translateY(0.15em)"
                                                            }}
                                                        />
                                                    </span>
                                                    <label style={{ cursor: "inherit" }}>Terrain</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div
                                            className="gm-style-mtc"
                                            style={{ float: "left", position: "relative" }}
                                        >
                                            <button
                                                draggable="false"
                                                aria-label="Show satellite imagery"
                                                title="Show satellite imagery"
                                                type="button"
                                                aria-pressed="false"
                                                style={{
                                                    background: "none padding-box rgb(255, 255, 255)",
                                                    display: "table-cell",
                                                    border: 0,
                                                    margin: 0,
                                                    padding: "0px 17px",
                                                    textTransform: "none",
                                                    appearance: "none",
                                                    position: "relative",
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                    direction: "ltr",
                                                    overflow: "hidden",
                                                    textAlign: "center",
                                                    height: 40,
                                                    verticalAlign: "middle",
                                                    color: "rgb(86, 86, 86)",
                                                    fontFamily: "Roboto, Arial, sans-serif",
                                                    fontSize: 18,
                                                    borderBottomRightRadius: 2,
                                                    borderTopRightRadius: 2,
                                                    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
                                                    minWidth: 64
                                                }}
                                                id="4688175B-ABCB-46B7-BE9A-67B643299779"
                                                aria-expanded="false"
                                            >
                                                Satellite
                                            </button>
                                            <ul
                                                role="menu"
                                                aria-labelledby="4688175B-ABCB-46B7-BE9A-67B643299779"
                                                style={{
                                                    backgroundColor: "white",
                                                    listStyle: "none",
                                                    padding: 2,
                                                    margin: 0,
                                                    zIndex: -1,
                                                    borderBottomLeftRadius: 2,
                                                    borderBottomRightRadius: 2,
                                                    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
                                                    position: "absolute",
                                                    right: 0,
                                                    top: 40,
                                                    textAlign: "left",
                                                    display: "none"
                                                }}
                                            >
                                                <li
                                                    tabIndex={-1}
                                                    role="menuitemcheckbox"
                                                    aria-label="Show imagery with street names"
                                                    draggable="false"
                                                    title="Show imagery with street names"
                                                    aria-checked="true"
                                                    style={{
                                                        color: "black",
                                                        fontFamily: "Roboto, Arial, sans-serif",
                                                        userSelect: "none",
                                                        fontSize: 18,
                                                        backgroundColor: "rgb(255, 255, 255)",
                                                        padding: "5px 8px 5px 5px",
                                                        direction: "ltr",
                                                        textAlign: "left",
                                                        whiteSpace: "nowrap"
                                                    }}
                                                >
                                                    <span>
                                                        <img
                                                            src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3Cpath%20d%3D%22M19%203H5c-1.11%200-2%20.9-2%202v14c0%201.1.89%202%202%202h14c1.11%200%202-.9%202-2V5c0-1.1-.89-2-2-2zm-9%2014l-5-5%201.41-1.41L10%2014.17l7.59-7.59L19%208l-9%209z%22/%3E%3C/svg%3E"
                                                            alt
                                                            style={{
                                                                height: "1em",
                                                                width: "1em",
                                                                transform: "translateY(0.15em)"
                                                            }}
                                                        />
                                                        <img
                                                            src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M19%205v14H5V5h14m0-2H5c-1.1%200-2%20.9-2%202v14c0%201.1.9%202%202%202h14c1.1%200%202-.9%202-2V5c0-1.1-.9-2-2-2z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E"
                                                            alt
                                                            style={{
                                                                height: "1em",
                                                                width: "1em",
                                                                transform: "translateY(0.15em)",
                                                                display: "none"
                                                            }}
                                                        />
                                                    </span>
                                                    <label style={{ cursor: "inherit" }}>Labels</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div />
                                <div />
                                <div />
                                <div>
                                    <button
                                        draggable="false"
                                        aria-label="Toggle fullscreen view"
                                        title="Toggle fullscreen view"
                                        type="button"
                                        className="gm-control-active gm-fullscreen-control"
                                        style={{
                                            background: "none rgb(255, 255, 255)",
                                            border: 0,
                                            margin: 10,
                                            padding: 0,
                                            textTransform: "none",
                                            appearance: "none",
                                            position: "absolute",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            borderRadius: 2,
                                            height: 40,
                                            width: 40,
                                            boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
                                            overflow: "hidden",
                                            display: "none",
                                            top: 0,
                                            right: 0
                                        }}
                                    >
                                        <img
                                            src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M0%200v6h2V2h4V0H0zm16%200h-4v2h4v4h2V0h-2zm0%2016h-4v2h6v-6h-2v4zM2%2012H0v6h6v-2H2v-4z%22/%3E%3C/svg%3E"
                                            alt
                                            style={{ height: 18, width: 18 }}
                                        />
                                        <img
                                            src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M0%200v6h2V2h4V0H0zm16%200h-4v2h4v4h2V0h-2zm0%2016h-4v2h6v-6h-2v4zM2%2012H0v6h6v-2H2v-4z%22/%3E%3C/svg%3E"
                                            alt
                                            style={{ height: 18, width: 18 }}
                                        />
                                        <img
                                            src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23111%22%20d%3D%22M0%200v6h2V2h4V0H0zm16%200h-4v2h4v4h2V0h-2zm0%2016h-4v2h6v-6h-2v4zM2%2012H0v6h6v-2H2v-4z%22/%3E%3C/svg%3E"
                                            alt
                                            style={{ height: 18, width: 18 }}
                                        />
                                    </button>
                                </div>
                                <div />
                                <div />
                                <div />
                                <div />
                                <div>
                                    <div
                                        className="gmnoprint gm-bundled-control gm-bundled-control-on-bottom"
                                        draggable="false"
                                        controlwidth={40}
                                        controlheight={153}
                                        style={{
                                            margin: 10,
                                            userSelect: "none",
                                            position: "absolute",
                                            bottom: 167,
                                            right: 40
                                        }}
                                    >
                                        <div
                                            className="gm-svpc"
                                            dir="ltr"
                                            title="Drag Pegman onto the map to open Street View"
                                            controlwidth={40}
                                            controlheight={40}
                                            style={{
                                                backgroundColor: "rgb(255, 255, 255)",
                                                boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
                                                borderRadius: 2,
                                                width: 40,
                                                height: 40,
                                                cursor:
                                                    'url("https://maps.gstatic.com/mapfiles/openhand_8_8.cur"), default',
                                                touchAction: "none",
                                                position: "absolute",
                                                left: 0,
                                                top: 0
                                            }}
                                        >
                                            <div style={{ position: "absolute", left: "50%", top: "50%" }} />
                                            <div style={{ position: "absolute", left: "50%", top: "50%" }}>
                                                <img
                                                    src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2023%2038%22%3E%3Cpath%20d%3D%22M16.6%2038.1h-5.5l-.2-2.9-.2%202.9h-5.5L5%2025.3l-.8%202a1.53%201.53%200%2001-1.9.9l-1.2-.4a1.58%201.58%200%2001-1-1.9v-.1c.3-.9%203.1-11.2%203.1-11.2a2.66%202.66%200%20012.3-2l.6-.5a6.93%206.93%200%20014.7-12%206.8%206.8%200%20014.9%202%207%207%200%20012%204.9%206.65%206.65%200%2001-2.2%205l.7.5a2.78%202.78%200%20012.4%202s2.9%2011.2%202.9%2011.3a1.53%201.53%200%2001-.9%201.9l-1.3.4a1.63%201.63%200%2001-1.9-.9l-.7-1.8-.1%2012.7zm-3.6-2h1.7L14.9%2020.3l1.9-.3%202.4%206.3.3-.1c-.2-.8-.8-3.2-2.8-10.9a.63.63%200%2000-.6-.5h-.6l-1.1-.9h-1.9l-.3-2a4.83%204.83%200%20003.5-4.7A4.78%204.78%200%200011%202.3H10.8a4.9%204.9%200%2000-1.4%209.6l-.3%202h-1.9l-1%20.9h-.6a.74.74%200%2000-.6.5c-2%207.5-2.7%2010-3%2010.9l.3.1L4.8%2020l1.9.3.2%2015.8h1.6l.6-8.4a1.52%201.52%200%20011.5-1.4%201.5%201.5%200%20011.5%201.4l.9%208.4zm-10.9-9.6zm17.5-.1z%22%20style%3D%22isolation%3Aisolate%22%20fill%3D%22%23333%22%20opacity%3D%22.7%22/%3E%3Cpath%20d%3D%22M5.9%2013.6l1.1-.9h7.8l1.2.9%22%20fill%3D%22%23ce592c%22/%3E%3Cellipse%20cx%3D%2210.9%22%20cy%3D%2213.1%22%20rx%3D%222.7%22%20ry%3D%22.3%22%20style%3D%22isolation%3Aisolate%22%20fill%3D%22%23ce592c%22%20opacity%3D%22.5%22/%3E%3Cpath%20d%3D%22M20.6%2026.1l-2.9-11.3a1.71%201.71%200%2000-1.6-1.2H5.699999999999999a1.69%201.69%200%2000-1.5%201.3l-3.1%2011.3a.61.61%200%2000.3.7l1.1.4a.61.61%200%2000.7-.3l2.7-6.7.2%2016.8h3.6l.6-9.3a.47.47%200%2001.44-.5h.06c.4%200%20.4.2.5.5l.6%209.3h3.6L15.7%2020.3l2.5%206.6a.52.52%200%2000.66.31l1.2-.4a.57.57%200%2000.5-.7z%22%20fill%3D%22%23fdbf2d%22/%3E%3Cpath%20d%3D%22M7%2013.6l3.9%206.7%203.9-6.7%22%20style%3D%22isolation%3Aisolate%22%20fill%3D%22%23cf572e%22%20opacity%3D%22.6%22/%3E%3Ccircle%20cx%3D%2210.9%22%20cy%3D%227%22%20r%3D%225.9%22%20fill%3D%22%23fdbf2d%22/%3E%3C/svg%3E"
                                                    aria-label="Street View Pegman Control"
                                                    style={{
                                                        height: 30,
                                                        width: 30,
                                                        position: "absolute",
                                                        transform: "translate(-50%, -50%)",
                                                        pointerEvents: "none"
                                                    }}
                                                />
                                                <img
                                                    src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2038%22%3E%3Cpath%20d%3D%22M22%2026.6l-2.9-11.3a2.78%202.78%200%2000-2.4-2l-.7-.5a6.82%206.82%200%20002.2-5%206.9%206.9%200%2000-13.8%200%207%207%200%20002.2%205.1l-.6.5a2.55%202.55%200%2000-2.3%202s-3%2011.1-3%2011.2v.1a1.58%201.58%200%20001%201.9l1.2.4a1.63%201.63%200%20001.9-.9l.8-2%20.2%2012.8h11.3l.2-12.6.7%201.8a1.54%201.54%200%20001.5%201%201.09%201.09%200%2000.5-.1l1.3-.4a1.85%201.85%200%2000.7-2zm-1.2.9l-1.2.4a.61.61%200%2001-.7-.3l-2.5-6.6-.2%2016.8h-9.4L6.6%2021l-2.7%206.7a.52.52%200%2001-.66.31l-1.1-.4a.52.52%200%2001-.31-.66l3.1-11.3a1.69%201.69%200%20011.5-1.3h.2l1-.9h2.3a5.9%205.9%200%20113.2%200h2.3l1.1.9h.2a1.71%201.71%200%20011.6%201.2l2.9%2011.3a.84.84%200%2001-.4.7z%22%20fill%3D%22%23333%22%20fill-opacity%3D%22.2%22/%3E%26quot%3B%3C/svg%3E"
                                                    aria-label="Pegman is on top of the Map"
                                                    style={{
                                                        display: "none",
                                                        height: 30,
                                                        width: 30,
                                                        position: "absolute",
                                                        transform: "translate(-50%, -50%)",
                                                        pointerEvents: "none"
                                                    }}
                                                />
                                                <img
                                                    src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2040%2050%22%3E%3Cpath%20d%3D%22M34-30.4l-2.9-11.3a2.78%202.78%200%2000-2.4-2l-.7-.5a6.82%206.82%200%20002.2-5%206.9%206.9%200%2000-13.8%200%207%207%200%20002.2%205.1l-.6.5a2.55%202.55%200%2000-2.3%202s-3%2011.1-3%2011.2v.1a1.58%201.58%200%20001%201.9l1.2.4a1.63%201.63%200%20001.9-.9l.8-2%20.2%2012.8h11.3l.2-12.6.7%201.8a1.54%201.54%200%20001.5%201%201.09%201.09%200%2000.5-.1l1.3-.4a1.85%201.85%200%2000.7-2zm-1.2.9l-1.2.4a.61.61%200%2001-.7-.3L28.4-36l-.2%2016.8h-9.4L18.6-36l-2.7%206.7a.52.52%200%2001-.66.31l-1.1-.4a.52.52%200%2001-.31-.66l3.1-11.3a1.69%201.69%200%20011.5-1.3h.2l1-.9h2.3a5.9%205.9%200%20113.2%200h2.3l1.1.9h.2a1.71%201.71%200%20011.6%201.2l2.9%2011.3a.84.84%200%2001-.4.7zM34%2029.6l-2.9-11.3a2.78%202.78%200%2000-2.4-2l-.7-.5a6.82%206.82%200%20002.2-5%206.9%206.9%200%2000-13.8%200%207%207%200%20002.2%205.1l-.6.5a2.55%202.55%200%2000-2.3%202s-3%2011.1-3%2011.2v.1a1.58%201.58%200%20001%201.9l1.2.4a1.63%201.63%200%20001.9-.9l.8-2%20.2%2012.8h11.3l.2-12.6.7%201.8a1.54%201.54%200%20001.5%201%201.09%201.09%200%2000.5-.1l1.3-.4a1.85%201.85%200%2000.7-2zm-1.2.9l-1.2.4a.61.61%200%2001-.7-.3L28.4%2024l-.2%2016.8h-9.4L18.6%2024l-2.7%206.7a.52.52%200%2001-.66.31l-1.1-.4a.52.52%200%2001-.31-.66l3.1-11.3a1.69%201.69%200%20011.5-1.3h.2l1-.9h2.3a5.9%205.9%200%20113.2%200h2.3l1.1.9h.2a1.71%201.71%200%20011.6%201.2l2.9%2011.3a.84.84%200%2001-.4.7z%22%20fill%3D%22%23333%22%20fill-opacity%3D%22.2%22/%3E%3Cpath%20d%3D%22M15.4%2038.8h-4a1.64%201.64%200%2001-1.4-1.1l-3.1-8a.9.9%200%2001-.5.1l-1.4.1a1.62%201.62%200%2001-1.6-1.4L2.3%2015.4l1.6-1.3a6.87%206.87%200%2001-3-4.6A7.14%207.14%200%20012%204a7.6%207.6%200%20014.7-3.1A7.14%207.14%200%200112.2%202a7.28%207.28%200%20012.3%209.6l2.1-.1.1%201c0%20.2.1.5.1.8a2.41%202.41%200%20011%201s1.9%203.2%202.8%204.9c.7%201.2%202.1%204.2%202.8%205.9a2.1%202.1%200%2001-.8%202.6l-.6.4a1.63%201.63%200%2001-1.5.2l-.6-.3a8.93%208.93%200%2000.5%201.3%207.91%207.91%200%20001.8%202.6l.6.3v4.6l-4.5-.1a7.32%207.32%200%2001-2.5-1.5l-.4%203.6zm-10-19.2l3.5%209.8%202.9%207.5h1.6V35l-1.9-9.4%203.1%205.4a8.24%208.24%200%20003.8%203.8h2.1v-1.4a14%2014%200%2001-2.2-3.1%2044.55%2044.55%200%2001-2.2-8l-1.3-6.3%203.2%205.6c.6%201.1%202.1%203.6%202.8%204.9l.6-.4c-.8-1.6-2.1-4.6-2.8-5.8-.9-1.7-2.8-4.9-2.8-4.9a.54.54%200%2000-.4-.3l-.7-.1-.1-.7a4.33%204.33%200%2000-.1-.5l-5.3.3%202.2-1.9a4.3%204.3%200%2000.9-1%205.17%205.17%200%2000.8-4%205.67%205.67%200%2000-2.2-3.4%205.09%205.09%200%2000-4-.8%205.67%205.67%200%2000-3.4%202.2%205.17%205.17%200%2000-.8%204%205.67%205.67%200%20002.2%203.4%203.13%203.13%200%20001%20.5l1.6.6-3.2%202.6%201%2011.5h.4l-.3-8.2z%22%20fill%3D%22%23333%22/%3E%3Cpath%20d%3D%22M3.35%2015.9l1.1%2012.5a.39.39%200%2000.36.42h.14l1.4-.1a.66.66%200%2000.5-.4l-.2-3.8-3.3-8.6z%22%20fill%3D%22%23fdbf2d%22/%3E%3Cpath%20d%3D%22M5.2%2028.8l1.1-.1a.66.66%200%2000.5-.4l-.2-3.8-1.2-3.1z%22%20fill%3D%22%23ce592b%22%20fill-opacity%3D%22.25%22/%3E%3Cpath%20d%3D%22M21.4%2035.7l-3.8-1.2-2.7-7.8L12%2015.5l3.4-2.9c.2%202.4%202.2%2014.1%203.7%2017.1%200%200%201.3%202.6%202.3%203.1v2.9m-8.4-8.1l-2-.3%202.5%2010.1.9.4v-2.9%22%20fill%3D%22%23e5892b%22/%3E%3Cpath%20d%3D%22M17.8%2025.4c-.4-1.5-.7-3.1-1.1-4.8-.1-.4-.1-.7-.2-1.1l-1.1-2-1.7-1.6s.9%205%202.4%207.1a19.12%2019.12%200%20001.7%202.4z%22%20style%3D%22isolation%3Aisolate%22%20fill%3D%22%23cf572e%22%20opacity%3D%22.6%22/%3E%3Cpath%20d%3D%22M14.4%2037.8h-3a.43.43%200%2001-.4-.4l-3-7.8-1.7-4.8-3-9%208.9-.4s2.9%2011.3%204.3%2014.4c1.9%204.1%203.1%204.7%205%205.8h-3.2s-4.1-1.2-5.9-7.7a.59.59%200%2000-.6-.4.62.62%200%2000-.3.7s.5%202.4.9%203.6a34.87%2034.87%200%20002%206z%22%20fill%3D%22%23fdbf2d%22/%3E%3Cpath%20d%3D%22M15.4%2012.7l-3.3%202.9-8.9.4%203.3-2.7%22%20fill%3D%22%23ce592b%22/%3E%3Cpath%20d%3D%22M9.1%2021.1l1.4-6.2-5.9.5%22%20style%3D%22isolation%3Aisolate%22%20fill%3D%22%23cf572e%22%20opacity%3D%22.6%22/%3E%3Cpath%20d%3D%22M12%2013.5a4.75%204.75%200%2001-2.6%201.1c-1.5.3-2.9.2-2.9%200s1.1-.6%202.7-1%22%20fill%3D%22%23bb3d19%22/%3E%3Ccircle%20cx%3D%227.92%22%20cy%3D%228.19%22%20r%3D%226.3%22%20fill%3D%22%23fdbf2d%22/%3E%3Cpath%20d%3D%22M4.7%2013.6a6.21%206.21%200%20008.4-1.9v-.1a8.89%208.89%200%2001-8.4%202z%22%20fill%3D%22%23ce592b%22%20fill-opacity%3D%22.25%22/%3E%3Cpath%20d%3D%22M21.2%2027.2l.6-.4a1.09%201.09%200%2000.4-1.3c-.7-1.5-2.1-4.6-2.8-5.8-.9-1.7-2.8-4.9-2.8-4.9a1.6%201.6%200%2000-2.17-.65l-.23.15a1.68%201.68%200%2000-.4%202.1s2.3%203.9%203.1%205.3c.6%201%202.1%203.7%202.9%205.1a.94.94%200%20001.24.49l.16-.09z%22%20fill%3D%22%23fdbf2d%22/%3E%3Cpath%20d%3D%22M19.4%2019.8c-.9-1.7-2.8-4.9-2.8-4.9a1.6%201.6%200%2000-2.17-.65l-.23.15-.3.3c1.1%201.5%202.9%203.8%203.9%205.4%201.1%201.8%202.9%205%203.8%206.7l.1-.1a1.09%201.09%200%2000.4-1.3%2057.67%2057.67%200%2000-2.7-5.6z%22%20fill%3D%22%23ce592b%22%20fill-opacity%3D%22.25%22/%3E%3C/svg%3E"
                                                    aria-label="Street View Pegman Control"
                                                    style={{
                                                        display: "none",
                                                        height: 40,
                                                        width: 40,
                                                        position: "absolute",
                                                        transform: "translate(-60%, -45%)",
                                                        pointerEvents: "none"
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="gmnoprint"
                                            controlwidth={40}
                                            controlheight={81}
                                            style={{ position: "absolute", left: 0, top: 72 }}
                                        >
                                            <div
                                                draggable="false"
                                                style={{
                                                    userSelect: "none",
                                                    boxShadow: "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px",
                                                    borderRadius: 2,
                                                    cursor: "pointer",
                                                    backgroundColor: "rgb(255, 255, 255)",
                                                    width: 40,
                                                    height: 81
                                                }}
                                            >
                                                <button
                                                    draggable="false"
                                                    aria-label="Zoom in"
                                                    title="Zoom in"
                                                    type="button"
                                                    className="gm-control-active"
                                                    style={{
                                                        background: "none",
                                                        display: "block",
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        textTransform: "none",
                                                        appearance: "none",
                                                        position: "relative",
                                                        cursor: "pointer",
                                                        userSelect: "none",
                                                        overflow: "hidden",
                                                        width: 40,
                                                        height: 40,
                                                        top: 0,
                                                        left: 0
                                                    }}
                                                >
                                                    <img
                                                        src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M18%207h-7V0H7v7H0v4h7v7h4v-7h7z%22/%3E%3C/svg%3E"
                                                        alt
                                                        style={{ height: 18, width: 18 }}
                                                    />
                                                    <img
                                                        src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M18%207h-7V0H7v7H0v4h7v7h4v-7h7z%22/%3E%3C/svg%3E"
                                                        alt
                                                        style={{ height: 18, width: 18 }}
                                                    />
                                                    <img
                                                        src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23111%22%20d%3D%22M18%207h-7V0H7v7H0v4h7v7h4v-7h7z%22/%3E%3C/svg%3E"
                                                        alt
                                                        style={{ height: 18, width: 18 }}
                                                    />
                                                </button>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        overflow: "hidden",
                                                        width: 30,
                                                        height: 1,
                                                        margin: "0px 5px",
                                                        backgroundColor: "rgb(230, 230, 230)",
                                                        top: 0
                                                    }}
                                                />
                                                <button
                                                    draggable="false"
                                                    aria-label="Zoom out"
                                                    title="Zoom out"
                                                    type="button"
                                                    className="gm-control-active"
                                                    style={{
                                                        background: "none",
                                                        display: "block",
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        textTransform: "none",
                                                        appearance: "none",
                                                        position: "relative",
                                                        cursor: "pointer",
                                                        userSelect: "none",
                                                        overflow: "hidden",
                                                        width: 40,
                                                        height: 40,
                                                        top: 0,
                                                        left: 0
                                                    }}
                                                >
                                                    <img
                                                        src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23666%22%20d%3D%22M0%207h18v4H0V7z%22/%3E%3C/svg%3E"
                                                        alt
                                                        style={{ height: 18, width: 18 }}
                                                    />
                                                    <img
                                                        src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M0%207h18v4H0V7z%22/%3E%3C/svg%3E"
                                                        alt
                                                        style={{ height: 18, width: 18 }}
                                                    />
                                                    <img
                                                        src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2018%2018%22%3E%3Cpath%20fill%3D%22%23111%22%20d%3D%22M0%207h18v4H0V7z%22/%3E%3C/svg%3E"
                                                        alt
                                                        style={{ height: 18, width: 18 }}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        style={{
                                            marginLeft: 5,
                                            marginRight: 5,
                                            zIndex: 1000000,
                                            position: "absolute",
                                            left: 0,
                                            bottom: 0
                                        }}
                                    >
                                        <a
                                            target="_blank"
                                            rel="noopener"
                                            href="https://maps.google.com/maps?ll=40.75198,-73.96978&z=11&t=m&hl=en-US&gl=US&mapclient=apiv3"
                                            title="Open this area in Google Maps (opens a new window)"
                                            style={{
                                                position: "static",
                                                overflow: "visible",
                                                float: "none",
                                                display: "inline"
                                            }}
                                        >
                                            <div style={{ width: 66, height: 26, cursor: "pointer" }}>
                                                <img
                                                    alt
                                                    src="https://maps.gstatic.com/mapfiles/api-3/images/google4.png"
                                                    draggable="false"
                                                    style={{
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0,
                                                        width: 66,
                                                        height: 26,
                                                        userSelect: "none",
                                                        border: 0,
                                                        padding: 0,
                                                        margin: 0
                                                    }}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        className="gmnoprint"
                                        style={{
                                            zIndex: 1000001,
                                            position: "absolute",
                                            right: 361,
                                            bottom: 0
                                        }}
                                    >
                                        <div
                                            draggable="false"
                                            className="gm-style-cc"
                                            style={{ userSelect: "none", height: 14, lineHeight: 14 }}
                                        >
                                            <div
                                                style={{
                                                    opacity: "0.7",
                                                    width: "100%",
                                                    height: "100%",
                                                    position: "absolute"
                                                }}
                                            >
                                                <div style={{ width: 1 }} />
                                                <div
                                                    style={{
                                                        backgroundColor: "rgb(245, 245, 245)",
                                                        width: "auto",
                                                        height: "100%",
                                                        marginLeft: 1
                                                    }}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    paddingRight: 6,
                                                    paddingLeft: 6,
                                                    boxSizing: "border-box",
                                                    fontFamily: "Roboto, Arial, sans-serif",
                                                    fontSize: 10,
                                                    color: "rgb(0, 0, 0)",
                                                    whiteSpace: "nowrap",
                                                    direction: "ltr",
                                                    textAlign: "right",
                                                    verticalAlign: "middle",
                                                    display: "inline-block"
                                                }}
                                            >
                                                <button
                                                    draggable="false"
                                                    aria-label="Keyboard shortcuts"
                                                    title="Keyboard shortcuts"
                                                    type="button"
                                                    style={{
                                                        background: "none",
                                                        display: "inline-block",
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        textTransform: "none",
                                                        appearance: "none",
                                                        position: "relative",
                                                        cursor: "pointer",
                                                        userSelect: "none",
                                                        color: "rgb(0, 0, 0)",
                                                        fontFamily: "inherit",
                                                        lineHeight: "normal"
                                                    }}
                                                >
                                                    Keyboard shortcuts
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="gmnoprint"
                                        style={{
                                            zIndex: 1000001,
                                            position: "absolute",
                                            right: 240,
                                            bottom: 0,
                                            width: 121
                                        }}
                                    >
                                        <div
                                            draggable="false"
                                            className="gm-style-cc"
                                            style={{ userSelect: "none", height: 14, lineHeight: 14 }}
                                        >
                                            <div
                                                style={{
                                                    opacity: "0.7",
                                                    width: "100%",
                                                    height: "100%",
                                                    position: "absolute"
                                                }}
                                            >
                                                <div style={{ width: 1 }} />
                                                <div
                                                    style={{
                                                        backgroundColor: "rgb(245, 245, 245)",
                                                        width: "auto",
                                                        height: "100%",
                                                        marginLeft: 1
                                                    }}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    paddingRight: 6,
                                                    paddingLeft: 6,
                                                    boxSizing: "border-box",
                                                    fontFamily: "Roboto, Arial, sans-serif",
                                                    fontSize: 10,
                                                    color: "rgb(0, 0, 0)",
                                                    whiteSpace: "nowrap",
                                                    direction: "ltr",
                                                    textAlign: "right",
                                                    verticalAlign: "middle",
                                                    display: "inline-block"
                                                }}
                                            >
                                                <button
                                                    draggable="false"
                                                    aria-label="Map Data"
                                                    title="Map Data"
                                                    type="button"
                                                    style={{
                                                        background: "none",
                                                        display: "none",
                                                        border: 0,
                                                        margin: 0,
                                                        padding: 0,
                                                        textTransform: "none",
                                                        appearance: "none",
                                                        position: "relative",
                                                        cursor: "pointer",
                                                        userSelect: "none",
                                                        color: "rgb(0, 0, 0)",
                                                        fontFamily: "inherit",
                                                        lineHeight: "normal"
                                                    }}
                                                >
                                                    Map Data
                                                </button>
                                                <span>Map data ©2021 Google</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            position: "absolute",
                                            userSelect: "none",
                                            height: 14,
                                            lineHeight: 14,
                                            right: 166,
                                            bottom: 0
                                        }}
                                        draggable="false"
                                        className="gm-style-cc"
                                    >
                                        <div
                                            style={{
                                                opacity: "0.7",
                                                width: "100%",
                                                height: "100%",
                                                position: "absolute"
                                            }}
                                        >
                                            <div style={{ width: 1 }} />
                                            <div
                                                style={{
                                                    backgroundColor: "rgb(245, 245, 245)",
                                                    width: "auto",
                                                    height: "100%",
                                                    marginLeft: 1
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                paddingRight: 6,
                                                paddingLeft: 6,
                                                boxSizing: "border-box",
                                                fontFamily: "Roboto, Arial, sans-serif",
                                                fontSize: 10,
                                                color: "rgb(0, 0, 0)",
                                                whiteSpace: "nowrap",
                                                direction: "ltr",
                                                textAlign: "right",
                                                verticalAlign: "middle",
                                                display: "inline-block"
                                            }}
                                        >
                                            <span>2 km&nbsp;</span>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    height: 8,
                                                    bottom: "-1px",
                                                    width: 38
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "100%",
                                                        height: 4,
                                                        position: "absolute",
                                                        left: 0,
                                                        top: 0
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        width: 4,
                                                        height: 8,
                                                        left: 0,
                                                        top: 0,
                                                        backgroundColor: "rgb(255, 255, 255)"
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        width: 4,
                                                        height: 8,
                                                        position: "absolute",
                                                        backgroundColor: "rgb(255, 255, 255)",
                                                        right: 0,
                                                        bottom: 0
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        backgroundColor: "rgb(102, 102, 102)",
                                                        height: 2,
                                                        left: 1,
                                                        bottom: 1,
                                                        right: 1
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        width: 2,
                                                        height: 6,
                                                        left: 1,
                                                        top: 1,
                                                        backgroundColor: "rgb(102, 102, 102)"
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        width: 2,
                                                        height: 6,
                                                        position: "absolute",
                                                        backgroundColor: "rgb(102, 102, 102)",
                                                        bottom: 1,
                                                        right: 1
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="gmnoprint gm-style-cc"
                                        draggable="false"
                                        style={{
                                            zIndex: 1000001,
                                            userSelect: "none",
                                            height: 14,
                                            lineHeight: 14,
                                            position: "absolute",
                                            right: 95,
                                            bottom: 0
                                        }}
                                    >
                                        <div
                                            style={{
                                                opacity: "0.7",
                                                width: "100%",
                                                height: "100%",
                                                position: "absolute"
                                            }}
                                        >
                                            <div style={{ width: 1 }} />
                                            <div
                                                style={{
                                                    backgroundColor: "rgb(245, 245, 245)",
                                                    width: "auto",
                                                    height: "100%",
                                                    marginLeft: 1
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                paddingRight: 6,
                                                paddingLeft: 6,
                                                boxSizing: "border-box",
                                                fontFamily: "Roboto, Arial, sans-serif",
                                                fontSize: 10,
                                                color: "rgb(0, 0, 0)",
                                                whiteSpace: "nowrap",
                                                direction: "ltr",
                                                textAlign: "right",
                                                verticalAlign: "middle",
                                                display: "inline-block"
                                            }}
                                        >
                                            <a
                                                href="https://www.google.com/intl/en-US_US/help/terms_maps.html"
                                                target="_blank"
                                                rel="noopener"
                                                style={{
                                                    textDecoration: "none",
                                                    cursor: "pointer",
                                                    color: "rgb(0, 0, 0)"
                                                }}
                                            >
                                                Terms of Use
                                            </a>
                                        </div>
                                    </div>
                                    <div
                                        draggable="false"
                                        className="gm-style-cc"
                                        style={{
                                            userSelect: "none",
                                            height: 14,
                                            lineHeight: 14,
                                            position: "absolute",
                                            right: 0,
                                            bottom: 0
                                        }}
                                    >
                                        <div
                                            style={{
                                                opacity: "0.7",
                                                width: "100%",
                                                height: "100%",
                                                position: "absolute"
                                            }}
                                        >
                                            <div style={{ width: 1 }} />
                                            <div
                                                style={{
                                                    backgroundColor: "rgb(245, 245, 245)",
                                                    width: "auto",
                                                    height: "100%",
                                                    marginLeft: 1
                                                }}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                position: "relative",
                                                paddingRight: 6,
                                                paddingLeft: 6,
                                                boxSizing: "border-box",
                                                fontFamily: "Roboto, Arial, sans-serif",
                                                fontSize: 10,
                                                color: "rgb(0, 0, 0)",
                                                whiteSpace: "nowrap",
                                                direction: "ltr",
                                                textAlign: "right",
                                                verticalAlign: "middle",
                                                display: "inline-block"
                                            }}
                                        >
                                            <a
                                                target="_blank"
                                                rel="noopener"
                                                title="Report errors in the road map or imagery to Google"
                                                dir="ltr"
                                                href="https://www.google.com/maps/@40.75198,-73.96978,11z/data=!10m1!1e1!12b1?source=apiv3&rapsrc=apiv3"
                                                style={{
                                                    fontFamily: "Roboto, Arial, sans-serif",
                                                    fontSize: 10,
                                                    color: "rgb(0, 0, 0)",
                                                    textDecoration: "none",
                                                    position: "relative"
                                                }}
                                            >
                                                Report a map error
                                            </a>
                                        </div>
                                    </div>
                                    <div
                                        className="gmnoscreen"
                                        style={{ position: "absolute", right: 0, bottom: 0 }}
                                    >
                                        <div
                                            style={{
                                                fontFamily: "Roboto, Arial, sans-serif",
                                                fontSize: 11,
                                                color: "rgb(0, 0, 0)",
                                                direction: "ltr",
                                                textAlign: "right",
                                                backgroundColor: "rgb(245, 245, 245)"
                                            }}
                                        >
                                            Map data ©2021 Google
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row py-4">
                            <div className="col-lg-6">
                                <h2 className="font-weight-bold text-8 mt-2 mb-0">Contact Us</h2>
                                <p className="mb-4">
                                    Feel free to ask for details, don't save any questions!
                                </p>
                                <form
                                    onSubmit={this.handleSubmit}
                                >
                                    <div className="contact-form-success alert alert-success d-none mt-4">
                                        <strong>Success!</strong> Your message has been sent to us.
                                    </div>
                                    <div className="contact-form-error alert alert-danger d-none mt-4">
                                        <strong>Error!</strong> There was an error sending your message.
                                        <span className="mail-error-message text-1 d-block" />
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label className="form-label mb-1 text-2">Full Name</label>
                                            <input
                                                type="text"
                                                defaultValue
                                                data-msg-required="Please enter your name."
                                                maxLength={100}
                                                className="form-control text-3 h-auto py-2"
                                                name="name"
                                                value={this.state.customer.firstName}
                                                onChange={this.handleFullNameChanged.bind(this)}
                                                required
                                            />
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label className="form-label mb-1 text-2">Email Address</label>
                                            <input
                                                type="email"
                                                defaultValue
                                                data-msg-required="Please enter your email address."
                                                data-msg-email="Please enter a valid email address."
                                                maxLength={100}
                                                className="form-control text-3 h-auto py-2"
                                                value={this.state.customer.email}
                                                onChange={this.handleemailChanged.bind(this)}
                                                name="email"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col">
                                            <label className="form-label mb-1 text-2">Subject</label>
                                            <input
                                                type="text"
                                                defaultValue
                                                data-msg-required="Please enter the subject."
                                                maxLength={100}
                                                className="form-control text-3 h-auto py-2"
                                                value={this.state.customer.subject}
                                                onChange={this.handlesubjectChanged.bind(this)}
                                                name="subject"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col">
                                            <label className="form-label mb-1 text-2">Message</label>
                                            <textarea
                                                maxLength={5000}
                                                data-msg-required="Please enter your message."
                                                rows={8}
                                                className="form-control text-3 h-auto py-2"
                                                name="message"
                                                value={this.state.customer.message}
                                                onChange={this.handlemessageChanged.bind(this)}
                                                required
                                                defaultValue={""}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col">
                                            <input
                                                type="submit"
                                                onClick={this.handleButtonClicked.bind(this)}
                                                defaultValue="Send Message"
                                                className="btn btn-primary btn-modern"
                                                data-loading-text="Loading..."
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="col-lg-6">
                                <div
                                    className="appear-animation animated fadeIn appear-animation-visible"
                                    data-appear-animation="fadeIn"
                                    data-appear-animation-delay={800}
                                    style={{ animationDelay: "800ms" }}
                                >
                                    <h4 className="mt-2 mb-1">
                                        Our <strong>Office</strong>
                                    </h4>
                                    <ul className="list list-icons list-icons-style-2 mt-2">
                                        <li>
                                            <i className="fas fa-map-marker-alt top-6" />{" "}
                                            <strong className="text-dark">Address:</strong> Creationist Technovations Pvt. Ltd.5th And 6th Floor, Plot No 436 Phase 4, Udyog Vihar, Gurugram 122001 Gurugram, HR, IN,India
                                        </li>
                                        <li>
                                            <i className="fas fa-phone top-6" />{" "}
                                            <strong className="text-dark">Phone:</strong> (123) 456-789
                                        </li>
                                        <li>
                                            <i className="fas fa-envelope top-6" />{" "}
                                            <strong className="text-dark">Email:</strong>{" "}
                                            <a href="mailto:mail@example.com">support@shopperr.in</a>
                                        </li>
                                    </ul>
                                </div>
                                <div
                                    className="appear-animation animated fadeIn appear-animation-visible"
                                    data-appear-animation="fadeIn"
                                    data-appear-animation-delay={950}
                                    style={{ animationDelay: "950ms" }}
                                >
                                    <h4 className="pt-5">
                                        Business <strong>Hours</strong>
                                    </h4>
                                    <ul className="list list-icons list-dark mt-2">
                                        <li>
                                            <i className="far fa-clock top-6" /> Monday - Friday - 9am to 5pm
                                        </li>
                                        <li>
                                            <i className="far fa-clock top-6" /> Saturday - 9am to 2pm
                                        </li>
                                        <li>
                                            <i className="far fa-clock top-6" /> Sunday - Closed
                                        </li>
                                    </ul>
                                </div>
                                <h4 className="pt-5">
                                    Get in <strong>Touch</strong>
                                </h4>
                                <p className="lead mb-0 text-4">
                                    Shopperr is a marketplace that makes it easy to find awesome products to sell online.
                                    Shopperr is a marketplace that makes it easy to find awesome products to sell online.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>




        )
    }
}


export default Contactus;